// extracted by mini-css-extract-plugin
export var chevronIcon = "_cj-2";
export var teamName = "_cj-1";
export var teamSwitcherButton = "_cj-0";